import { setTerm } from './helpers';

export const setHasFinishing = setTerm('has_decoration');
